/* tslint:disable */
/* eslint-disable */
/**
 * Profile API
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: v0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */


/**
 * 
 * @export
 */
export const CorporateProgram = {
    Vinci: 'VINCI'
} as const;
export type CorporateProgram = typeof CorporateProgram[keyof typeof CorporateProgram];


export function instanceOfCorporateProgram(value: any): boolean {
    for (const key in CorporateProgram) {
        if (Object.prototype.hasOwnProperty.call(CorporateProgram, key)) {
            // @ts-ignore
            if (CorporateProgram[key] === value) {
                return true;
            }
        }
    }
    return false;
}

export function CorporateProgramFromJSON(json: any): CorporateProgram {
    return CorporateProgramFromJSONTyped(json, false);
}

export function CorporateProgramFromJSONTyped(json: any, ignoreDiscriminator: boolean): CorporateProgram {
    return json as CorporateProgram;
}

export function CorporateProgramToJSON(value?: CorporateProgram | null): any {
    return value as any;
}

